import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '影视作品', to: '/category' },
  { label: '明星资料', to: '/stars' },
  { label: '动态资讯', to: '/news' },
  { label: '关于我们', to: '/about' },
];

const friendLinks = [
  { label: 'The Movie Database', href: 'https://flbang.cc' },
  { label: 'IMDb 影视资料库', href: 'https://www.imdb.com' },
  { label: '影视行业观察', href: 'https://flbang.cc/movie' },
];

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-primary-900 text-primary-100">
      <div className="mx-auto grid w-full gap-8 px-4 py-12 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-accent-950">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="font-heading text-base font-bold text-background-50">河北彩花影视大全</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-primary-200">
            聚合河北彩花的影视作品、明星资料与最新动态，为影视爱好者与粉丝提供清晰、全面的资料查阅体验。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/" className="transition-colors hover:text-accent-400">站内导航</Link>
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-200">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="transition-colors hover:text-accent-400">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <a href="https://flbang.cc" rel="nofollow" className="transition-colors hover:text-accent-400">友情链接</a>
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-200">
            {friendLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="transition-colors hover:text-accent-400"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/about" className="transition-colors hover:text-accent-400">联系我们</Link>
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              feedback@hbh-movie-demo.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              内容更新时间：每日
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-information-line"></i>
              本站为前端演示站点
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-6">
          <p>© 2026 河北彩花影视大全 · 本站内容均为示范演示，不代表真实业务状态。</p>
          <p>影视作品与明星资料均为示例数据，仅供学习交流使用。</p>
        </div>
      </div>
    </footer>
  );
}